import "./css/App.css";

// components
import Convertor from "./components/Converter";

function App() {
  return (
    <div className="main-container">
      <Convertor />
    </div>
  );
}

export default App;
